let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});




// If transperent
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
var topbar = document.querySelector(".announce-main-wipper");
if (transperentElment) {
    header.classList.add("allow-transparent-header");
    topbar.classList.add("allow-transparent-header");
}

// short description more less text PDP

document.addEventListener("DOMContentLoaded", function() {
  const shortDesc = document.querySelector(".short-description");
  if (!shortDesc) return;

  const moreBtn = shortDesc.querySelector(".more-text");
  const lessBtn = shortDesc.querySelector(".less-text");
  const shortContent = shortDesc.querySelector(".short");
  const fullContent = shortDesc.querySelector(".full");

  if (moreBtn) {
    moreBtn.addEventListener("click", () => {
      shortContent.style.display = "none";
      fullContent.style.display = "inline";
      moreBtn.style.display = "none";
      lessBtn.style.display = "inline";
    });
  }

  if (lessBtn) {
    lessBtn.addEventListener("click", () => {
      shortContent.style.display = "inline";
      fullContent.style.display = "none";
      moreBtn.style.display = "inline";
      lessBtn.style.display = "none";
    });
  }
});

// tab PDP

document.addEventListener("DOMContentLoaded", function() {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  const tabHeadings = document.querySelectorAll(".content-title");

  if (tabButtons.length > 0) {
    // Default: First tab active
    tabButtons[0].classList.add("active");
    tabContents[0].classList.remove("hidden");
    tabHeadings[0].classList.remove("hidden");

    // Hide all others
    for (let i = 1; i < tabContents.length; i++) {
      tabContents[i].classList.add("hidden");
      tabHeadings[i].classList.add("hidden");
    }

    tabButtons.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        // Reset all
        tabButtons.forEach(b => b.classList.remove("active"));
        tabContents.forEach(c => c.classList.add("hidden"));
        tabHeadings.forEach(h => h.classList.add("hidden"));

        // Activate clicked
        btn.classList.add("active");
        tabContents[index].classList.remove("hidden");
        tabHeadings[index].classList.remove("hidden");
      });
    });
  }
});

// Vertical Slider 

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".reviewSwiper", {
    direction: "vertical",
    autoHeight: true,
    slidesPerView: 2,
    spaceBetween: 20,
    mousewheel: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      749: {
        slidesPerView: 2, 
      }
    }
  });
});

// Cart Drawer Upsell Slider
document.addEventListener("DOMContentLoaded", function() {
  var container = document.querySelector(".cartdrawer-upsell-wrap.swiper");
  if (!container || !window.Swiper) return;

  new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true,
    navigation: {
      nextEl: ".upsell_products .swiper-button-next",
      prevEl: ".upsell_products .swiper-button-prev"
    }
  });
});

// Custom banner counter code
document.addEventListener("DOMContentLoaded", function() {
  const sliders = document.querySelectorAll(".custom-banner_slider [data-slide-show-main]");

  sliders.forEach((slider) => {
    const options = slider.dataset.sliderOptions ? JSON.parse(slider.dataset.sliderOptions) : {};
    const swiper = new Swiper(slider, options);

    const totalEl = slider.closest(".custom-banner_slider")?.querySelector(".show_totle-slide_number");
    const activeEl = slider.closest(".custom-banner_slider")?.querySelector(".show_active_number");
    if (totalEl) {
      const totalSlides = slider.querySelectorAll(".custom-banner_slider .swiper-slide:not(.swiper-slide-duplicate)").length;
      totalEl.textContent = totalSlides < 10 ? `${totalSlides}` : totalSlides;
    }

    const updateActiveSlide = () => {
      if (!activeEl) return;
      let realIndex = swiper.realIndex + 1;
      activeEl.textContent = realIndex < 10 ? `${realIndex}` : realIndex;
    };

    swiper.on("init", updateActiveSlide);
    swiper.on("slideChange", updateActiveSlide);

    swiper.init();
  });
});

// header menu close icon trigger
document.querySelectorAll('.hender-close').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.header__icon.header__icon--menu').forEach(function(menuIcon) {
            menuIcon.click();
        });
    });
});


// Book Slier Code
// document.addEventListener("DOMContentLoaded", function () {
//   var swiper = new Swiper(".swiper-custom-book", {
//     slidesPerView: 3,
//     loop: false,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     speed: 700,

//     // ✅ Enable smooth touch movement
//     simulateTouch: true,
//     touchRatio: 1,
//     touchAngle: 45,
//     grabCursor: true,
//     threshold: 5, // minimum px movement before swipe triggers
//     freeMode: false, // set true if you want free scrolling
//     resistanceRatio: 0.85, // for smoother touch resistance
//   });
// //console.log("swiper",swiper);

// });
// ✅ Move collage section below 750px screen width
if (document.body.clientWidth < 750) {
  const lastCollage = document.querySelector(".mezga-section .grid_mezga_footer");
  const collageSecond = document.querySelector(".mezga-section .bottom-gallery");
  if (lastCollage && collageSecond) {
    collageSecond.after(lastCollage);
  }
}

// tab triiger click 
document.addEventListener("DOMContentLoaded", function () {
  const hash = window.location.hash;

  if (hash) {
    const targetBtn = document.querySelector('#tab-click');

    if (targetBtn) {
      targetBtn.click();

      // Scroll smoothly AFTER tab opens
      setTimeout(() => {
        const header = document.querySelector("header"); // your fixed header
        const headerHeight = header ? header.offsetHeight : 100; // fallback 100

        const targetPosition = targetBtn.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = targetPosition - headerHeight - 20; // 20 extra padding

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 300); // delay to allow tab to open
    }
  }
});

// // popup open the header btn
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".header-btn-reserve.reserver-btn");
  console.log("openBtn",openBtn);
  const modal = document.getElementById("otPopup");
  const closeBtn = document.querySelector(".ot-close");

  // Open popup
  openBtn.addEventListener("click", function () {
    console.log("hello!!!");
    modal.style.display = "block";
  });

  // Close popup
  closeBtn.addEventListener("click", function () {
    modal.style.display = "none";
  });

  // Close popup when clicking outside content
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });
});
